import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Typography, Divider, Button, TextField, FormHelperText } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import FaceIcon from "@mui/icons-material/Face";
import Chip from "@mui/material/Chip";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { showrequestinfluencercodeApi, requestinfluencercodeApi, editrequestinfluencercodeApi } from "../../../../../services/InfluencerApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";


function InfluencerTabs(props) {
  const [msg, setMsg] = useState("لطفا صبر کنید")
  const [requestId, setRequestId] = useState(false)
  const [requestState, setRequestState] = useState("initial")
  const [requestText, setRequestText] = useState("")
  const [contactPhone, setContactPhone] = useState("")
  const [contactEmail, setContactEmail] = useState("")
  const [descriptionAdmin, setDescriptionAdmin] = useState("")

  const sendRequest = async () => {
    if (!requestText || !contactPhone || !contactEmail) {
      customToastify("error", "لطفا تمام گزینه ها را پرکنید");
    } else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        let data = { requestText, contactPhone, contactEmail }
        const response = await requestinfluencercodeApi(data);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setMsg(resData["message"] || "درخواست انجام شد")
          setRequestState("sendRequest")
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          setMsg(resData["message"] || "مشکلی وجود دارد")
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
        setMsg(errMsg || "مشکلی وجود دارد")
        console.error(error);
      }
    }

  }

  const editRequest = async () => {
    if (!requestText || !contactPhone || !contactEmail) {
      customToastify("error", "لطفا تمام گزینه ها را پرکنید");
    } else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        let data = { requestText, contactPhone, contactEmail }
        if (requestId) data["requestId"] = requestId
        const response = await editrequestinfluencercodeApi(data);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setMsg(resData["message"] || "درخواست انجام شد")
          setRequestState("sendRequest")
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          setMsg(resData["message"] || "مشکلی وجود دارد")
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
        setMsg(errMsg || "مشکلی وجود دارد")
        console.error(error);
      }
    }

  }
  const checkStatus = async () => {
    // let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await showrequestinfluencercodeApi({});
      const resData = checkResponseData(response);
      if (resData["success"]) {
        setMsg(resData["message"] || "درخواست انجام شد")
        // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setRequestText(resData["data"]["data"][0]["requestText"])
        setContactPhone(resData["data"]["data"][0]["contactPhone"])
        setContactEmail(resData["data"]["data"][0]["contactEmail"])
        setDescriptionAdmin(resData["data"]["data"][0]["descriptionAdmin"])
        if (resData["data"]["data"][0]["situation"] == "needEdit" || !resData["data"]["data"][0]["situation"]) {
          setRequestState("showForm")
          setRequestId(resData["data"]["data"][0]["_id"])
        } else if (resData["data"]["data"][0]["situation"] == "edited") {
          setRequestState("edited")
        } else if (resData["data"]["data"][0]["situation"] == "confirmed") {
          setRequestState("confirmed")
        } else if (resData["data"]["data"][0]["situation"] == "rejected") {
          setRequestState("rejected")
        } else if (resData["data"]["data"][0]["situation"] == "newRequest") {
          setRequestState("newRequest")
        } else {
          setRequestState("problem")
        }
      } else {
        setMsg(resData["message"] || "درخواست انجام شد")
        // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
      setMsg(errMsg || "مشکلی وجود دارد")
      console.error(error);
    }
  }

  const showData = (selected) => {
    switch (selected) {
      case "showForm":
        return (
          <>
            {requestId ? <Typography sx={{ color: "brown", mb: 2 }}>
              درخواست شما نیاز به ویرایش دارد
              <br />
              {descriptionAdmin}
            </Typography> : <Divider sx={{ mt: 1 }}>
              <Chip label="ارسال درخواست جدید" size="small" />
            </Divider>}
            <Box sx={{ display: "flex", size: "small", alignItems: "center", my: 0.5 }}>
              <Typography sx={{ width: "100px" }}>
                شماره تماس :
              </Typography>
              <TextField value={contactPhone} label="شماره تماس :" size="small" variant="outlined" onChange={(e) => { setContactPhone(e.target.value) }} />
            </Box>
            <Box sx={{ display: "flex", size: "small", alignItems: "center", my: 0.5 }}>
              <Typography sx={{ width: "100px" }}>
                آدرس ایمیل :
              </Typography>
              <TextField value={contactEmail} label="آدرس ایمیل:" size="small" variant="outlined" onChange={(e) => { setContactEmail(e.target.value) }} />
            </Box>
            <Box sx={{ display: "flex", size: "small", alignItems: "center", my: 0.5 }}>
              <Typography sx={{ width: "100px" }}>
                توضیحات :
              </Typography>
              <TextField
                sx={{ width: "70%" }}
                multiline
                value={requestText}
                onChange={(e) => { setRequestText(e.target.value) }}
                rows={4}
              />
            </Box>
            <Box>
              <Button variant="contained" sx={{ m: 1, textAlign: "center" }}
                onClick={requestId ? editRequest : sendRequest}
              >
                ارسال درخواست
              </Button>
            </Box>
          </>
        );
      case "sendRequest":
        return (
          <Typography sx={{ color: "green" }}>
            درخواست با موفقیت ارسال شد لطفا منتظر تماس از سمت همکاران ما باشید
          </Typography>
        );
      case "initial":
        return (
          <Typography sx={{ color: "green" }}>
            لطفا صبر کنید
          </Typography>
        );
      case "newRequest":
        return (
          <Typography sx={{ color: "green" }}>
            درخواست شما ثبت شده است لطفا منتظر تماس و یا ارسال کد باشید
            <br />
            {descriptionAdmin}
          </Typography>
        );
      case "edited":
        return (
          <Typography sx={{ color: "green" }}>
            ویرایش درخواست با موفقیت انجام شده است لطفا منتظر تماس از سمت همکاران ما باشید
          </Typography>
        );
      case "confirmed":
        return (
          <Typography sx={{ color: "green" }}>
            با ارسال کد برای شما موافقیت شده است و یک کد به ایمیل و یا شماره تماس شما ارسال خواهد شد
            <br />
            {descriptionAdmin}
          </Typography>
        );
      case "rejected":
        return (
          <Typography sx={{ color: "green" }}>
            متاسفانه با درخواست شما موافقت نشده است
            <br />
            {descriptionAdmin}
          </Typography>
        );

      default:
        return "مشکلی وجود دارد";
    }
  };
  useEffect(() => {
    checkStatus()
  }, [])
  return (
    <Paper sx={{ m: 1, textAlign: "center" }}>
      <Typography sx={{ p: 1 }}>
        {msg}
      </Typography>
      <Box sx={{ textAlign: "justify", m: 1 }}>
        {showData(requestState)}

      </Box>
      <Box sx={{ textAlign: "justify", m: 1 }}>
        <Typography>
          تیم مارکتینگ اوملنگ با فعالان در حوزه زبان تماس گرفته و کد همکاری ویژه آنها را در اختیارشان قرار می دهد.</Typography>
        <Typography>
          اما چنانچه استاد زبان هستید و یا شبکه اجتماعی با تعداد فالوور زیاد دارید شما نیز می توانید با ما همکاری کنید.
        </Typography>

        <Typography>
          کافی است که فرم بالا را پرکنید تا همکاران ما با شما تماس بگیرند و پس از بررسی شرایط کد را به ایمیل و یا شماره تلفن شما ارسال کنند.
        </Typography>
      </Box>
    </Paper>
  );
}

export default InfluencerTabs;
